import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2ezqktgbr7: FaireBrandEntity = {
  token: "b_2ezqktgbr7",
  type: "brand",
  name: "LilAryenne | Jewelry & Suncatchers (Import Fees Covered)",
  avatarUrl:
    "https://cdn.faire.com/fastly/7f80f62e24b8f64f7abefcf449702f43093486b4cb892784cb73cfd82863559b.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/9d58124316a39115a9b472d9232a35cd201aecf147e93852dc749d1949bd4fec.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/7f80f62e24b8f64f7abefcf449702f43093486b4cb892784cb73cfd82863559b.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/9d58124316a39115a9b472d9232a35cd201aecf147e93852dc749d1949bd4fec.jpeg",
  location: "CYP",
  minimumOrderDollars: 0,
  rating: 4.9,
  reviewCount: 111,
  isTopShop: true,
  isInsider: true,
  description:
    "✨ |Shipping & Fees|\n• All import duties are handled by us;\n• Typical shipping cost is approximately 5–10% of the order value, depending on volume and destination;\n• Estimated delivery time: 7–12 business days;\nThis ensures a smooth, predictable ordering experience with no hidden costs or surprises.\n\nFounded in 2020, LilAryenne creates enchanting jewelry and suncatchers designed to bring light, beauty, and positive energy into everyday spaces.\n\nFrom gemstone jewelry that blends elegance and intention, to suncatchers that fill rooms with dancing rainbows, each piece is thoughtfully designed to inspire joy, balance, and connection.\n\nWhether you’re sourcing meaningful gifts or eye-catching display pieces for your store, we’re here to make wholesale simple, transparent, and magical ✨\n\nWith love and gratitude,\nLilAryenne 🌟",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:05.612Z",
    importedBy: "entity-db-cli",
  },
};
